var Model = require('../Model');

var Room = Object.create(Model);

Room.name = 'Room';
Room['@class'] = 'Room';
Room.url = 'room';
Room.parentClass = 'Location';
Room.fields = {
  parent: {
    default: null,
    hidden: true
	},
  name:{
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 64, default: ''},
    }
  },
  roomNumber:{
    type: 'text',
    default: null,
    validators: {
      presence: true, 
      length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  geojson:{
    type: 'text',
    default: null,
  },
  svg: {
    type: 'textarea',
    default: '',
  },
  svgConverted: {
    type: 'textarea',
    default: '',
    hidden: true
  },
  diagramSvg: {
    type: 'textarea',
    default: '',
  },
  diagramSvgConverted: {
    type: 'textarea',
    default: '',
    hidden: true
  },
  ports: {
    type: 'text',
    default: {},
    hidden: true
  },
  defaultMapView: {
    default: null,
    type: 'text',
  }
}

module.exports = Room;
